module.exports = __webpack_public_path__ + "assets/img/gar5-5.3077835d.jpg";